import ButtonIcon from 'components/ButtonIcon';
import { ConfirmModal, getConfirmation } from 'components/ConfirmModal';
import { enqueueSnackbar } from 'components/Snackbar';
import rowStyles from 'components/table/GridRow/index.module.pcss';
import { Typo } from 'components/typography/Typo';
import { AccountAWSItem } from 'models/sensors/aws/dto';
import { deleteAccountAWSFx } from 'models/sensors/aws/effects';
import styles from '../index.module.css';

type Props = {
	name: AccountAWSItem['role_arn'];
	id: AccountAWSItem['id'];
};

export function CompletedDeleteButton({ name, id }: Props) {
	async function onDelete() {
		if (!(await confirm(name))) {
			return;
		}

		await deleteAccountAWSFx(id);

		enqueueSnackbar('AWS connection deleted');
	}

	async function confirm(role_arn: string) {
		const confirmDeletionModal = (
			<ConfirmModal
				title="Delete AWS connection"
				confirmProps={{
					children: 'Delete',
				}}
				disableUntilEntered={role_arn}
				placeholder="Role ARN"
			>
				<Typo variant="D/Regular/Body-S" className={styles.modalText}>
					Connection to{' '}
					<Typo variant="D/Medium/Body-S" component="span" data-test="aws-account-delete-name">
						{role_arn}
					</Typo>{' '}
					will be reset. Automatic infrastructure discovery will stop.
					<br />
					Enter the Role ARN to confirm the deletion.
				</Typo>
			</ConfirmModal>
		);

		return await getConfirmation(confirmDeletionModal);
	}

	return (
		<ButtonIcon
			size="S"
			icon="Delete/Filled"
			onClick={onDelete}
			className={rowStyles.showWhenFocus}
			dataTest="aws-account-completed-delete-button"
		/>
	);
}
